export default __webpack_public_path__ + "static/media/22.0be1c344.jpg";